module.exports = __webpack_public_path__ + "img/microneedling-circle-fill.4cbdd6bd.svg";